/*
 * SBV: make Return apply a cart quantity instead of doing nothing.
 *
 * The fault, measured on the live theme with a trusted key event: a rider
 * retypes a quantity on /cart or in the cart drawer and presses Return. The
 * field shows the new number, the cart keeps the old one, the subtotal never
 * moves, and NOT ONE cart request is sent. The rider can then check out at a
 * quantity and a price they believe they changed. That is an order-value
 * bug, not a cosmetic one.
 *
 * Why it happens: the quantity input is name="updates[]" inside form#cart,
 * whose only submit buttons are the Check out buttons. Something in the
 * theme already suppresses the implicit submission that Return would
 * otherwise trigger, which is correct (Return should never send a rider to
 * checkout), but nothing applies the typed quantity in its place. So the
 * keystroke is swallowed and the rider is told nothing.
 *
 * What this does: on Return inside a cart quantity field, cancel the
 * submission explicitly and dispatch the same change event the field fires
 * on blur, which is the path the theme already uses to update the line.
 * Verified on staging: dispatching change on that input takes the line from
 * 3 to 2 through the vendor's own update.
 *
 * Rules it keeps:
 *   - Capture phase on document, because the keydown never reaches the
 *     input's own listeners; an ancestor stops it first.
 *   - Only cart quantity fields. A Return anywhere else is untouched.
 *   - Only when the typed value actually differs from the value the server
 *     rendered, so Return on an unchanged field sends nothing.
 *   - Never throws. A failure here must never break typing in a field.
 *   - Bound once per page.
 */
(function () {
  'use strict';

  if (window.__sbvQtyEnterBound) { return; }
  window.__sbvQtyEnterBound = true;

  function isCartQuantityField(el) {
    try {
      if (!el || el.tagName !== 'INPUT') { return false; }
      if ((el.className || '').indexOf('quantity__input') === -1) { return false; }
      // Both cart surfaces, and nothing else: the cart page line items and
      // the drawer. A product page quantity field is not a cart line.
      return !!(el.closest('#main-cart-items') || el.closest('cart-drawer'));
    } catch (e) {
      return false;
    }
  }

  function committedValue(el) {
    // defaultValue is the value attribute as Liquid rendered it, which is
    // the quantity the server currently holds for this line.
    try {
      return String(el.defaultValue || '').trim();
    } catch (e) {
      return '';
    }
  }

  document.addEventListener('keydown', function (event) {
    try {
      if (!event || event.key !== 'Enter') { return; }
      if (event.ctrlKey || event.metaKey || event.altKey) { return; }

      var field = event.target;
      if (!isCartQuantityField(field)) { return; }

      // Return must never submit the cart form. Its only submit buttons are
      // Check out, so an implicit submission would send the rider to
      // checkout on a keystroke they meant as "apply this number".
      event.preventDefault();

      var typed = String(field.value || '').trim();
      if (typed === '' || typed === committedValue(field)) { return; }

      // The theme already listens for change on this field. Dispatching it
      // is exactly what blurring the field does, so the quantity travels the
      // path that is already proven, with no second code path to maintain.
      field.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {
      /* never interfere with typing */
    }
  }, true);
})();
